import { Component, OnInit, Input } from '@angular/core';
import { AcpService } from '@services/common/acp.service';
import { PlatformDetect } from '@libs/platform/platform-detect';
import { FactoryService } from '@services/common/factory.service';

@Component({
  standalone: false,
  selector: 'com-loading',
  templateUrl: './com-loading.component.html',
  styleUrls: ['./com-loading.component.scss']
})
export class ComLoadingComponent implements OnInit{
  public loagingGif: string;
  public isWeb: boolean = false;
  public language: string;
  public baseLoagingGif: string;
  public showWebUI: boolean = false; //only for show Mobile UI in website

  constructor(
    private acpSer: AcpService,
    private platform: PlatformDetect,
    private factorySer: FactoryService,
  ) { 
    this.initData();
  }

  private async initData() { 
    this.language = await this.factorySer.getLanguage(); 
    this.isWeb = this.platform.isPcWeb();
    this.loagingGif = this.acpSer?.acpData ? this.acpSer.getAcpMedia('Profile.Comon.Loading.Mickey.Gif') : null;
    const pathName = window.location.pathname;
    this.showWebUI = this.isWeb && /(guest-list)|(add-edit)/.test(pathName);
  }
    
  async ngOnInit() { }

}
